import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../../contexts/AuthContext";
import { SubscriptionContext } from "../../contexts/SubscriptionContext";
import { toast } from "react-toastify";
import { withTranslation } from "react-i18next";
import AuthModal from "../AuthModal";
import "./style.css";
import img1 from "../../images/1 (1).png";
import img3 from "../../images/3 (1).png";

class Opportunity extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.state = {
      redirectTo: null,
      redirectState: null,
      showAuthModal: false,
    };
  }

  handleEnrollClick = (e) => {
    e.preventDefault();
    const { isAuthenticated } = this.context;

    if (isAuthenticated) {
      // User is logged in, redirect to subscribe page
      this.setState({ redirectTo: "/subscribe" });
    } else {
      // User is not logged in, redirect to subscribe page for simplified enrollment
      this.setState({ redirectTo: "/subscribe" });
    }
  };

  handleDemoClick = (e) => {
    e.preventDefault();
    const { isAuthenticated } = this.context;
    const { t } = this.props;

    console.log('Opportunity - handleDemoClick - isAuthenticated:', isAuthenticated);

    if (!isAuthenticated) {
      console.log('Opportunity - Opening AuthModal for demo');
      this.setState({ showAuthModal: true });
    } else {
      // User is authenticated, handle demo logic
      const { hasActiveSubscription } = this.context;
      if (hasActiveSubscription) {
        toast.info(t('opportunity.alreadySubscribed'));
        this.setState({ redirectTo: "/dashboard" });
      } else {
        this.setState({ redirectTo: "/demo-confirmation" });
      }
    }
  };

  render() {
    const { t, i18n } = this.props;
    const isRTL = i18n.language === 'ar';
    const textAlign = isRTL ? 'right' : 'left';

    if (this.state.redirectTo) {
      return (
        <Navigate
          to={this.state.redirectTo}
          state={this.state.redirectState}
          replace
        />
      );
    }

    // Get subscription context
    const subscriptionContext = this.context;
    var settings = {
      dots: false,
      arrows: false,
      speed: 1000,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: false, // No autoplay on desktop
      autoplaySpeed: 3000,
      infinite: true,
      pauseOnHover: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            autoplay: false,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            autoplay: false,
          },
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
          },
        },
      ],
    };

    const opportunities = [
      {
        title: t('opportunity.enrollToday'),
        description: t('opportunity.enrollDescription'),
        image: img1,
        link: "/subscribe", // Changed from "/simplified-enroll" to "/subscribe"
        state: null,
      },
      {
        title: t('opportunity.requestDemo'),
        description: t('opportunity.demoDescription'),
        image: img3,
        link: "/signup",
        state: { action: "demo" },
      },
      // Removed the third card as requested
    ];
    return (
      <section className="wpo-testimonials-section section-padding">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-4 col-lg-12">
              <div
                className="testimonials-left"
                style={{ textAlign }}
              >
                <span>{t('opportunity.sectionTitle')}</span>
                <h3>{t('opportunity.joinAnas')}</h3>
                <p style={{ textAlign }}>
                  {t('opportunity.description')}
                </p>
                <a
                  href="/contact"
                  className="theme-btn"
                  style={{ marginLeft: "0" }}
                >
                  {t('opportunity.reachOut')}
                </a>
              </div>
            </div>
            <div className="col-xl-8 col-lg-12">
              <div className="testimonials-wrapper owl-carousel">
                <Slider {...settings}>
                  {opportunities.map((opportunity, index) => (
                    <div className="testimonials-item" key={index}>
                      <div
                        className="testimonials-item-top opportunity-card"
                        style={{ textAlign }}
                      >
                        <h3 style={{ textAlign }}>
                          {opportunity.title}
                        </h3>
                        <p style={{ textAlign }}>
                          {opportunity.description}
                        </p>
                        <div className="opportunity-image">
                          <img
                            src={opportunity.image}
                            alt={opportunity.title}
                            loading="lazy"
                            decoding="async"
                          />
                        </div>
                        <div className="opportunity-button">
                          <SubscriptionContext.Consumer>
                            {({ isPaidSubscription, hasActiveSubscription }) => (
                              <a
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  const { isAuthenticated } = this.context;

                                  if (opportunity.title === t('opportunity.enrollToday')) {
                                    if (!isAuthenticated) {
                                      // Redirect to subscribe page for unauthenticated users
                                      this.setState({
                                        redirectTo: "/subscribe",
                                      });
                                    } else if (isPaidSubscription) {
                                      toast.info(t('opportunity.alreadySubscribed'));
                                      this.setState({ redirectTo: "/dashboard" });
                                    } else {
                                      // Allow demo users to upgrade
                                      this.setState({ redirectTo: "/subscribe" });
                                    }
                                  } else {
                                    // Request Free Demo
                                    this.handleDemoClick(e);
                                  }
                                }}
                                className="theme-btn-s2"
                              >
                                {opportunity.title}
                              </a>
                            )}
                          </SubscriptionContext.Consumer>
                        </div>
                      </div>
                    </div>
                  ))}
                </Slider>
              </div>
            </div>
          </div>
        </div>

        {/* Authentication Modal */}
        <AuthModal
          isOpen={this.state.showAuthModal}
          onClose={() => this.setState({ showAuthModal: false })}
          title={t('opportunity.accountRequired')}
          message={t('opportunity.accountRequiredMessage')}
          type="demo"
          redirectState={{ action: 'demo' }}
        />
      </section>
    );
  }
}

export default withTranslation()(Opportunity);